export default __webpack_public_path__ + "static/media/infoIcon.abc30023.svg";